import { brand } from '@alison/ui';

export const ALISON_TEXT_SECONDARY = '#596678';
export const ALISON_TEXT_SUBTLE = '#818897';
export const ALISON_TEXT_TITLE = '#1B212D';
export const ALISON_TEXT_DISABLED = '#BDBDBD';
export const ALISON_SELECTED = '#EDF2FF';
export const ALISON_DIVIDER_SOFT = '#E9ECEF';

export const ALISON_TILE_GRADIENTS = {
  report: 'linear-gradient(135deg, #FFEEFC 3.125%, #FFCDF4 100%)',
  storyboards: 'linear-gradient(135deg, #F0FFF6 3.125%, #CCE9E7 100%)',
  brief: 'linear-gradient(135deg, #FFF6F3 3.125%, #EAB8A2 100%)',
} as const;

export const ALISON_THUMBNAIL_GRADIENT = 'linear-gradient(150.6deg, #E3F8EC 3.125%, #CCE9D8 100%)';
export const ALISON_BORDER_GRADIENT = `linear-gradient(135deg, ${brand.blue}, ${brand.violet})`;
export const ALISON_FLOATING_SHADOW =
  '0 2px 8px rgba(152, 16, 250, 0.08), 0 2px 16px rgba(21, 93, 252, 0.16)';
export const ALISON_DRAWER_CTA_GRADIENT = `linear-gradient(114deg, ${brand.blue} 0%, ${brand.violet} 100%)`;
export const ALISON_INTRO_CTA_GRADIENT = `linear-gradient(105deg, ${brand.blue} 0%, ${brand.violet} 100%)`;
export const ALISON_PROGRESS_GRADIENT = `linear-gradient(90deg, ${brand.violet}, ${brand.blue})`;
